import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetDataFlowDeviceDetailsResData extends ApiGenericResponse {
    deviceDetails: {};
    isDeviceDetailAlreadySent: boolean;
    isDeviceDetailIncomplete: boolean;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(obj: any) {
        if (obj.DeviceDetail) this.deviceDetails = obj.DeviceDetail;
        if (obj.IsDeviceDetailSent != null && obj.IsDeviceDetailSent != undefined) this.isDeviceDetailAlreadySent = obj.IsDeviceDetailSent;
        if (obj.IsDeviceDetailIncomplete != null && obj.IsDeviceDetailIncomplete != undefined) this.isDeviceDetailIncomplete = obj.IsDeviceDetailIncomplete;
    }
}
